import React from "react";
const icon = (
  <svg
    width="320"
    height="512"
    viewBox="0 0 320 512"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M80 160C80 124.7 108.7 96 144 96H176C211.3 96 240 124.7 240 160V163.6C240 185.4 228.9 205.7 210.6 217.4L168.4 244.5C143.2 260.7 128 288.6 128 318.5V320C128 337.7 142.3 352 160 352C177.7 352 192 337.7 192 320V318.6C192 310.4 196.2 302.8 203 298.4L245.2 271.3C281.8 247.7 304 207.2 304 163.6V160C304 89.3 246.7 32 176 32H144C73.3 32 16 89.3 16 160C16 177.7 30.3 192 48 192C65.7 192 80 177.7 80 160ZM160 480C170.609 480 180.783 475.786 188.284 468.284C195.786 460.783 200 450.609 200 440C200 429.391 195.786 419.217 188.284 411.716C180.783 404.214 170.609 400 160 400C149.391 400 139.217 404.214 131.716 411.716C124.214 419.217 120 429.391 120 440C120 450.609 124.214 460.783 131.716 468.284C139.217 475.786 149.391 480 160 480Z"
      fill="#8803E9"
    />
  </svg>
);

export default icon;
